module.exports = __webpack_public_path__ + "static/media/InHouseISOPortal.9ccc2a30.svg";